// import router from 'vue-router'

const actions = {
    getMyProfile: ({commit}, ApiClient) => {
         return ApiClient.User.getMe().then(res => {
            if (res.status === 200) {
                var user = checkUserRole(res.data)
                commit('setMe', user)
            }
            return user
        }).catch((err) => {
            return err
        });

    },
    getUser: ({commit}, ID, ApiClient) => {
        ApiClient.User.getUser(ID).then(res => {
            if (res.status === 200)
                return res
        }).catch((err) => {
            return err
        });

    },
    getUsersFromApi: ({commit}, ApiClient) => {
        ApiClient.User.getUsers().then(res => {
            if (res.status === 200) {
                commit('setUsers', res.data)
            }
        }).catch((err) => {
            return err
        });

    },
    putUser: ({commit, dispatch}, payload) => {
        var ApiClient = payload.ApiClient
        if (!payload.user.company_id) {
            payload.user.company_id = payload.user.company.id
        }
        return ApiClient.User.createUser(payload.user).then(res => {

            if (res.status === 201) {
                dispatch('getUsersFromApi', ApiClient)
                return res.data

            }
            if (res.status === 400) {
                this.$toasted.global.failedRequest({message: res.data.message});
                return res.data
            }
            return res

        }).catch(err => {

            return err
        })
    },
    setPassword: ({commit, dispatch}, payload) => {
        let ApiClient = payload.ApiClient
        return ApiClient.User.setPassword({password: payload.newPassword}).then((res) => {
            return res
        }).catch(() => {

        })
    },
    setUserToApp: ({commit}, payload) => {
        let ApiClient = payload.ApiClient
        let USER_ID = payload.user
        let app = payload.id
        // return true
        return ApiClient.User.setUserToApp(USER_ID, app).then(res => {
            if (res.status === 201) {
                return true
            } else {
                return false
            }
        }).catch(() => {
            // Vue.toasted.global.failedRequest({
            //     message : 'Something went wrong while fetching companies'
            // });
        });
    },
    removeUserFromApp: ({commit}, payload) => {
        let ApiClient = payload.ApiClient
        let USER_ID = payload.user
        let app = payload.app

        // return true
        return ApiClient.User.removeUserFromApp(USER_ID, app).then(res => {
            if (res.status === 200) {
                return true
            } else {
                return false
            }
        }).catch((e) => {
            return e
            // Vue.toasted.global.failedRequest({
            //     message : 'Something went wrong while fetching companies'
            // });
        });
    },

}

export default actions

function checkUserRole(user) {

    if (user.type === "user") {
        user.user = true
    }
    if (user.type === "admin") {
        user.user = true, user.admin = true
    }
    if (user.type === "root") {
        user.user = true, user.admin = true, user.root = true
    }

    return user
}